import React from "react";
import { FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <footer
      className="bg-[#E35D26] text-white text-[12px] font-medium text-center font-sans p-3"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2 md:gap-0">
        <span className="text-center md:text-left">
          All rights reserved © AICEE (All India Combined Entrance Examination)
        </span>

        <a
          href="https://www.instagram.com/aicee_indiaofficial?utm_source=qr&igsh=dmlhem5oZnZnMTJ5"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 hover:opacity-90 transition-opacity duration-200 text-decoration-none text-white"
        >
          <span>Follow us</span>
          <FaInstagram className="text-white text-[18px]" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
